module.exports = __webpack_public_path__ + "static/1288965935.09796941.jpg";